import { signal } from '@preact/signals-react'
import type { RoomLink } from './roomLink.types'

export function makeRoomLink(_baseUrl: string): RoomLink {
  const roomName = signal<string | null>(null)

  if (typeof window !== 'undefined') {
    // Initial parse
    const parseUrl = () => {
      const match = window.location.pathname.match(/^\/r\/([^\/]+)/)
      roomName.value = match ? match[1] : null
    }
    parseUrl()

    // Listen for history changes (if any manual pushState happens outside of init.ts)
    // Note: init.ts also handles URL syncing, so there might be some overlap,
    // but RoomLink is primarily for exposing the room name to the UI (Header, etc).
    // For now, we'll keep it simple and just parse on load.
    // If we need reactive URL updates, we can add a listener.
  }

  return {
    roomName,
    disconnect: () => {
      // Cleanup listeners if any
    }
  }
}
